
import { ApiService } from "./apiService";
import { ChatHistory, ChatRequest, ChatResponse } from "../common/models";

export class ChatService {
  private api: ApiService;

  constructor(apiService: ApiService) {
    this.api = apiService;
  }


  async streamingApiEndpoint(request: ChatRequest, abortSignal: AbortSignal): Promise<Response> {
    return this.api.stream(request, abortSignal);
  }

  async updateStreamingApiEndpoint(request: ChatRequest, abortSignal: AbortSignal): Promise<Response> {
    return this.api.stream(request, abortSignal, request.messageId);
  }

  async completionApiEndpoint(request: ChatRequest, abortSignal: AbortSignal): Promise<ChatResponse> {
    return await this.api.post<ChatRequest, ChatResponse>("/api/complete", request, abortSignal);
  }


  async historyBySessionApiEndpoint(request: ChatRequest, abortSignal: AbortSignal): Promise<ChatHistory> {

    return await this.api.get<ChatHistory>(`/api/history/${request.sessionId}`, abortSignal);
  }

  async historyApiEndpoint(abortSignal: AbortSignal): Promise<ChatHistory> {

    return await this.api.get<ChatHistory>("/api/history", abortSignal);
  }

  async clearHistoryApiEndpoint(abortSignal: AbortSignal): Promise<Response> {
    return await this.api.put("/api/history/clear", abortSignal);
  }

  async clearSessionHistoryApiEndpoint(sessionId: string, abortSignal: AbortSignal): Promise<Response> {
    return await this.api.put(`/api/history/clear/${sessionId}`, abortSignal);
  }

  async getTaskUserSessionsApiEndpoint(taskId: string, userId: string, abortSignal: AbortSignal): Promise<any> {
    return await this.api.get(`/api/task/${taskId}/user/${userId}`, abortSignal);
  }

  async getConversationBySessionIdApiEndpoint(sessionId: string, abortSignal: AbortSignal): Promise<ChatHistory> {
    return await this.api.get<ChatHistory>(`/api/conversation/${sessionId}`, abortSignal);
  }

  async playgroundChatApiEndpoint(formData: FormData, abortSignal: AbortSignal): Promise<Response> {
    return await this.api.postFormData("/api/playground-chat", formData, abortSignal);
  }
}